import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import type { ActionPoint } from '@devices';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ActionPointService {
  private http = inject(HttpClient);

  getActionPoints() {
    return this.http
      .get<{ data: ActionPoint[]; }>(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/action-points`)
      .pipe(map(response => response.data));
  }

  getActionPointsByDeviceId(deviceId: string) {
    return this.http
      .get<{ data: ActionPoint[]; }>(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/action-points/device/${deviceId}`)
      .pipe(map(response => response.data));
  }

  createActionPoint(payload: Pick<ActionPoint, 'name' | 'friendlyName'>) {
    return this.http
      .post<{ data: ActionPoint; }>(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/action-points`, payload)
      .pipe(map(response => response.data));
  }

  editActionPoint(id: string, payload: Partial<ActionPoint>) {
    return this.http
      .patch<{ data: ActionPoint; }>(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/action-points/${id}`, payload)
      .pipe(map(response => response.data));
  }

  deleteActionPoint(id: string) {
    return this.http.delete(`devices/v1/clients/${CURRENT_CLIENT_TEMPLATE_VAR}/action-points/${id}`);
  }
}
